import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Firefox is slow, Lodash is fast",
  "description": "",
  "published": "2016-09-16T00:00:00.000Z",
  "redirect_from": ["/blog/firefox-is-slow-lodash-is-fast/swizec/7034"],
  "categories": "Technical",
  "hero": "./img/fXP7fLs.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "775px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/da9201f14bcfae948289b355143c9aa4/0098c/fXP7fLs.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.15695067264574%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'220\\'%20viewBox=\\'0%200%20400%20220\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M280%2010h-20c-1-1-3%200-3%202s19%203%2019%200h1l3%202c3%200%203%200%203-3s0-3-3-1m61%2093c0%2073-1%2075-2%2024v-5h-10v30c0%2027-1%2030-2%2030-2%200-2-2-2-34v-34h-11v34l-1%2034V99h-10v42c0%2037%200%2039-1%2021-1-29-1-33-2-31%200%201-1%202-3%201l-3%201-1-3-1%2024c0%2027%200%2027-1%2012l-1-27v-11h-10v26a405%20405%200%2001-1-1v-28h-10v28c0%2026-1%2029-2%2029-2%200-2-3-2-47V88h-10l-1%2047-1%2047V89h-10v46l-1%2046-1-31-1-25-1%204h-3c-3%200-3%200-3-3a765%20765%200%2000-2%2055l-1-55V70h-10v56c0%2048-1%2051-1%2018v-39h-10v27a2237%202237%200%2000-3%2050c-1%200-2-18-2-43%200-2%200-2-5-2h-5v46l-1-22v-21h-10v21l-1%2020-1-13c0-8%200-13-1-11%200%201-1%202-5%201l-4-1v13c0%207-1%201-1-13v-25h-10v47l-1%202-1-19v-19h-10v20c0%2018%200%2019-2%2019s-2-1-2-36v-37h-10v36a435%20435%200%2001-1-1v-38h-11v38a805%20805%200%2001-2-10c0%203-1%204-4%204l-3-1-1-1-1%2024c0%2016-1%208-1-31V76h-10v53a1863%201863%200%2001-2-5c0-3%200-3-5-3h-5v30c0%2028-1%2031-2%2031-2%200-2-3-2-55V72H74l-1%2055-1%2055V38H62v72c0%2060%200%2067-1%2041-1-47-1-53-2-50%200%202-1%203-3%202l-3%201-1-6-1%2037a1392%201392%200%2001-2-71V41H39v70c0%2058-1%2062-1%2023V86H28v47c0%2045%200%2048-2%2049a17534%2017534%200%2000361%200c-2%200-2-3-2-43V97h-10v42a864%20864%200%2001-1-15V67h-10v7l-1%2058-1%2050v-41l-1-34-1%206c0-1-1-2-3-1-2%200-3%200-3-2l-1-1-1%2037c-1%2029-1%2020-1-43V24h-10v79\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/da9201f14bcfae948289b355143c9aa4/ca0a1/fXP7fLs.webp 223w", "/static/da9201f14bcfae948289b355143c9aa4/75680/fXP7fLs.webp 445w", "/static/da9201f14bcfae948289b355143c9aa4/05e2a/fXP7fLs.webp 775w"],
              "sizes": "(max-width: 775px) 100vw, 775px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/da9201f14bcfae948289b355143c9aa4/e92b6/fXP7fLs.png 223w", "/static/da9201f14bcfae948289b355143c9aa4/e66bf/fXP7fLs.png 445w", "/static/da9201f14bcfae948289b355143c9aa4/0098c/fXP7fLs.png 775w"],
              "sizes": "(max-width: 775px) 100vw, 775px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/da9201f14bcfae948289b355143c9aa4/0098c/fXP7fLs.png",
              "alt": "fXP7fLs",
              "title": "fXP7fLs",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Look at those colors! Aren’t they shiny?`}</p>
    <p>{`They’re super shiny (unless you’re color blind), but what do they mean? I’m glad you asked. That’s a speed comparison chart of 6 ways to clone JavaScript objects, run in 5 browsers, on 2 devices: my laptop and my iPhone 5SE.`}</p>
    <p>{`You can try the benchmark yourself:`}</p>
    <p>{`>`}<a parentName="p" {...{
        "href": "http://swizec.github.io/compare-copy-methods"
      }}>{`Click here.`}</a>{` `}{`<`}{` I’d make an iframe, but it freezes my browser for many seconds at a time. It even freezes the CSS animation on that React logo.`}</p>
    <p><img parentName="p" {...{
        "src": "/6ee012b61fa5303ffa299d402fd2d84b/BZP9d05.gif",
        "alt": null
      }}></img></p>
    <p>{`Dangerous business those benchmarks.`}</p>
    <p>{`Firefox is the only browser that decides something weird is going on and throws a warning. Everyone else happily blocks JS, CSS, and UI.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "464px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/c81c1c11a8bd844d91ae1d70cb2b3845/69096/1TpGCEO.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.39461883408072%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'178\\'%20viewBox=\\'0%200%20400%20178\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M38%2020c2%200%202%200%200%202-1%201-1%201%201%201l-1%201c-3%201-3%201%201%201%206%200%2010%202%2011%205%202%204%201%208-2%2011l-4%205-3%202c-4%200-4-5%200-9s4-7%200-8c-2%200-3%200-4%202s-2%203-4%203c-3%200-3%200-3-4l1-4-5%203-6%204-1-2%203-6%203-5-3%203C9%2042%2020%2065%2041%2065c20%200%2031-23%2019-40l-5-3c-2%201-4%200-2-1l-2-1a133%20133%200%2001-13%200m197%20142l1%206h73v-6c0-5%200-5-1-1l-1%202c0-1-4-1-5%201l-3-1c-1-1-6%201-6%202l-1%201-1-1-1-1c-2%200-2-1-2-3s0-2-1%200-1%203-7%203l-8-1c-1-2-7%200-8%202s-2%201-2-1%200-2-1-1h-24l-1-2c-1-4-1-4-1%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c81c1c11a8bd844d91ae1d70cb2b3845/ca0a1/1TpGCEO.webp 223w", "/static/c81c1c11a8bd844d91ae1d70cb2b3845/75680/1TpGCEO.webp 445w", "/static/c81c1c11a8bd844d91ae1d70cb2b3845/f5c43/1TpGCEO.webp 464w"],
              "sizes": "(max-width: 464px) 100vw, 464px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c81c1c11a8bd844d91ae1d70cb2b3845/e92b6/1TpGCEO.png 223w", "/static/c81c1c11a8bd844d91ae1d70cb2b3845/e66bf/1TpGCEO.png 445w", "/static/c81c1c11a8bd844d91ae1d70cb2b3845/69096/1TpGCEO.png 464w"],
              "sizes": "(max-width: 464px) 100vw, 464px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/c81c1c11a8bd844d91ae1d70cb2b3845/69096/1TpGCEO.png",
              "alt": "1TpGCEO",
              "title": "1TpGCEO",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Now, is this benchmark fair? I don’t know. Running benchmarks on a computer that’s doing a bunch of other stuff is never `}<em parentName="p">{`really`}</em>{` fair. Maybe a different tab just tried to do something, or Spotify downloaded a song, or Dropbox ran a metadata update on my entire hard drive.`}</p>
    <p>{`A bunch of things can affect these results. That’s why you can `}<a parentName="p" {...{
        "href": "http://swizec.github.io/compare-copy-methods"
      }}>{`run it yourself`}</a>{`. But I did my best to ensure fairness as much as I could.`}</p>
    <ul>
      <li parentName="ul">{`Each test runs alone, asynchronously`}</li>
      <li parentName="ul">{`Each test is re-run 20-times`}</li>
      <li parentName="ul">{`Each test uses the same source data`}</li>
      <li parentName="ul">{`Each test produces the same deep-ish cloned dataset`}</li>
    </ul>
    <p>{`I say “deep-ish” because we’re cloning an array of some 81,000 objects. The objects are shallow, which means we can cut corners.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const experiments = {
  "lodash _.cloneDeep": _.cloneDeep,
  ".map + lodash _.clone": (arr) => arr.map((d) => _.clone(d)),
  ".map + lodash _.assign": (arr) => arr.map((d) => _.assign({}, d)),
  "JSON string/parse": (arr) => JSON.parse(JSON.stringify(arr)),
  ".map + Object.assign": (arr) => arr.map((d) => Object.assign({}, d)),
  ".map + React's update()": (arr) => arr.map((d) => update({}, { $merge: d })),
};
`}</code></pre>
    <p>{`We use `}<inlineCode parentName="p">{`_.cloneDeep`}</inlineCode>{` without understanding context. This is a little bit unfair because it tries to do too much. We run `}<inlineCode parentName="p">{`_.clone`}</inlineCode>{`, `}<inlineCode parentName="p">{`_.assign`}</inlineCode>{`, `}<inlineCode parentName="p">{`Object.assign`}</inlineCode>{`, and `}<a parentName="p" {...{
        "href": "https://facebook.github.io/react/docs/update.html"
      }}>{`React’s `}<inlineCode parentName="a">{`update`}</inlineCode></a>{` in a loop. They benefit from not trying to work in the general case. `}<inlineCode parentName="p">{`JSON.parse/stringify`}</inlineCode>{` is on the same level as `}<inlineCode parentName="p">{`_.cloneDeep`}</inlineCode>{`: naïve, complete, works for anything.`}</p>
    <p>{`I’m gobsmacked that for datasets this big, you’re better off converting to JSON and back than using Lodash’s `}<inlineCode parentName="p">{`cloneDeep`}</inlineCode>{` function. I have no idea how that’s even possible. Maybe JSON benefits from an implementation detail deep in the engine?`}</p>
    <p>{`But then why is `}<inlineCode parentName="p">{`_.assign`}</inlineCode>{` faster than `}<inlineCode parentName="p">{`Object.assign`}</inlineCode>{`? They both make a shallow copy of an object, but `}<inlineCode parentName="p">{`Object.assign`}</inlineCode>{` is a language feature, and `}<inlineCode parentName="p">{`_.assign`}</inlineCode>{` is implemented in pure JavaScript.`}</p>
    <p>{`I think … how else? I hope `}<a parentName="p" {...{
        "href": "https://twitter.com/jdalton"
      }}>{`@jdalton`}</a>{` can shed some light on this.`}</p>
    <p>{`You can see the entire test runner on Github `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/compare-copy-methods/blob/master/src/App.js"
      }}>{`here`}</a>{`. There are a few comments, but the interesting bit is this `}<inlineCode parentName="p">{`runner`}</inlineCode>{` function. It ensure fairness by isolating timing to only the cloning method.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`    runner(name, method) {
        let data = this.state.data;

        const times = d3.range(0, this.N).map(() => {
            const t1 = new Date();

            let copy = method(data);

            const t2 = new Date();
            return t2 - t1;
        });

        let results = this.state.results;
        results.push({name: name,
                      avg: d3.mean(times)});

        this.setState({results: results});
    }
`}</code></pre>
    <p>{`The runner itself is called asynchronously via `}<inlineCode parentName="p">{`setTimeout(foo, 0)`}</inlineCode>{`, and the `}<inlineCode parentName="p">{`async`}</inlineCode>{` library ensures tests don’t happen in parallel. Inside `}<inlineCode parentName="p">{`runner`}</inlineCode>{`, we iterate through `}<inlineCode parentName="p">{`N = 20`}</inlineCode>{` indexes, take timestamp, perform clone, take another timestamp, and construct an array of time diffs. Then we use `}<inlineCode parentName="p">{`d3.mean`}</inlineCode>{` to get the average and add it to `}<inlineCode parentName="p">{`this.state.results`}</inlineCode>{` with `}<inlineCode parentName="p">{`setState`}</inlineCode>{`.`}</p>
    <p>{`It runs in React because I’m lazy and `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{` is the quickest way to set everything up :)`}</p>
    <p>{`Maybe there’s some unfairness in how Babel compiles this code? That’s possible ?`}</p>
    <p>{`My conclusion is this: Use the appropriate algorithm for your use-case, and run your code in Chrome.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      